import { BasicStyledComponent, DSPageSection } from 'shared-definitions/types'

interface PostNavLinkProps extends BasicStyledComponent {
  section: DSPageSection
  onClick?: () => void
}

const PostNavLink: React.FC<PostNavLinkProps & React.PropsWithChildren> = ({
  children,
  className,
  section,
  onClick,
}) => (
  <a
    href={`#${section.anchor}`}
    rel="nofollow"
    className={className}
    onClick={e => {
      const el = document.getElementById(section.anchor)
      if (el) {
        e.preventDefault()
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        if (onClick) {
          onClick()
        }
      }
    }}
  >
    {children ?? section.label}
  </a>
)

export default PostNavLink
